import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  role: "presentation"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.5 12a9.5 9.5 0 1 0-19 0 9.5 9.5 0 0 0 19 0m-6.458 2.777a.5.5 0 0 1 .85.527C15.078 16.619 13.642 17.5 12 17.5s-3.078-.881-3.892-2.196a.5.5 0 0 1 .85-.527C9.602 15.818 10.728 16.5 12 16.5c1.273 0 2.398-.682 3.042-1.723M9.1 8.5a.5.5 0 0 1 .5.5v.08a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5zm5.989 0a.5.5 0 0 1 .5.5v.08a.5.5 0 0 1-.5.5H15a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5zM22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12"
    }, null, -1)
  ]))]))
}
export default { render: render }